export const selectMonitoreosMediosImpState = (state) => state.monitoreosMediosImp;

export const selectMonitoreosMediosImpFormState = (state) => state.monitoreosMediosImp.form;
